import {
   ReceptionServiceWithPractitionersSimple,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { createInterpolatedTranslationKey, createTranslatedText, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';
import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { TextPattern } from '@dreryk/watermelon';

import { translationKeys } from '../../../translations';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

import { NoServiceItem, ServicesControllerItem } from './ServicesController.types';
import { NO_SERVICE_ITEM } from './ServicesController';

const isSelectedItemNoSerivceOption = (item: ServicesControllerItem): item is NoServiceItem => item === 'NO_SERVICE';

export const creatServicesTriggerLabelExtractor = (
   totalCount: number,
   translate: TranslateFunction
): ((chosenPractitioners: ServicesControllerItem[]) => string) => {
   return (chosenOptions) => {
      if (chosenOptions.length === 1) {
         const [firstOption] = chosenOptions;
         return isSelectedItemNoSerivceOption(firstOption) ? translate(translationKeys.noService) : firstOption.name;
      }
      const translationKey = createInterpolatedTranslationKey(translationKeys.chosenOptions, {
         count: chosenOptions.length,
         totalCount: totalCount,
      });
      return translate(translationKey);
   };
};

export const createServicesCodec = (
   services: ServicesControllerItem[]
): FilterPanelControllerCodecConfigArray<ServicesControllerItem> => ({
   type: 'array',
   items: [NO_SERVICE_ITEM, ...services],
   keyGenerator: (item) => (isSelectedItemNoSerivceOption(item) ? item : item.id.toString()),
   mode: 'string',
});

export const servicesDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   ServicesControllerItem[],
   WaitlistFilterPanelSearchParam.SERVICES
> = (currentItems) => {
   return currentItems.map((item) => {
      if (isSelectedItemNoSerivceOption(item)) {
         return {
            targetValue: currentItems.filter((currentItem) => currentItem !== 'NO_SERVICE'),
            label: translationKeys.noService,
            testId: 'noService',
         };
      }
      return {
         targetValue: currentItems.filter((currentService) =>
            isSelectedItemNoSerivceOption(currentService) ? true : currentService.id.asNumber() !== item.id.asNumber()
         ),
         label: createTranslatedText(item.name),
         testId: `service-${item.id}`,
      };
   });
};

export const receptionServiceWithPractitionerSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<ReceptionServiceWithPractitionersSimple[]> =>
      performCqrsQuerySearch<ReceptionServiceWithPractitionersSimple>(() => {
         const receptionServiceWithPractitionersSimpleQuery = new ReceptionServiceWithPractitionersSimpleQuery();
         receptionServiceWithPractitionersSimpleQuery.name = searchText
            ? TextPattern.anywhereIgnoreCase(searchText)
            : undefined;
         return receptionServiceWithPractitionersSimpleQuery;
      });
};
